import React, { useEffect, useRef, useState } from "react";
import Loaders from "../Loaders";
import HeaderTop from "../HeaderTop";
import Menus from "../Menus";
import Footers from "../Footers";
import '../../../libs/css/bootstrap.min3.3.7.css';
import '../../../libs/css/sweetalert2.min.css';
import { API_ROUTES } from "../../../utils/constants";
import Nulls from "../Nulls";
import { format } from "date-fns";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
// import RevenuesTable from "./RevenuesTable";
import Swal from "sweetalert2";
import RevenuesTable from "./RevenuesTable";
import RevenueChart from "./RevenueChart";


export default function Revenues(props){
    const {objectToFormData, errorFunction, Helmet, capitalizeWords, isAuthExpired, today, resetTimeToMidnight, resetTimeToB4Midnight, formatDate, allCPs, isLoading1 } = props;

    useEffect(() => {document.title = "Revenue | Forthsoft"}, []);

    const [isLoading, setIsLoading] = useState(true);
    const [dataCount, setDataCount] = useState(0);
    const [dataRevenue, setDataRevenue] = useState([]);
    const [columns, setColumns] = useState([]);
    const [page, setPage] = useState(1);
    const countPerPage = 20;
    const [isFade, setIsFade] = useState(true);
    const [cpSelected, setCpSelected] = useState('');
    const [registerName, setRegisterName] = useState('service');
    const clearInputs = useRef(null);
    const [allSessions, setAllSessions] = useState([]);
    const [rawBreakdown, setRawBreakdown] = useState([]);
    const [chartData, setChartData] = useState([]);
    const [chartCompanies, setChartCompanies] = useState([]);

    const transformBreakdown = (breakdown) => {
        const grouped = {};
        breakdown.forEach(item => {
            const date = item.date;
            const company = item.company;
            const amount = Number(item.dailyChargeAmount);
            if (!grouped[date]) grouped[date] = { date };
            grouped[date][company] = amount;
        });
        return Object.values(grouped);
    };

    const networkData = [
        { id: "1", name: "MTN" },
        { id: "2", name: "GLO" },
        { id: "3", name: "AIRTEL" },
        { id: "4", name: "9MOBILE" },
    ];


    const columns1 = [
        {   
            name: 'Counts',
            selector: row => row.count ? row.count.toLocaleString() : 0,
            sortable: true,
        },
        {
            name: 'Total Revenue',
            selector: row => row.totalRevenue ? "₦" + row.totalRevenue.toLocaleString() : "₦0",
            sortable: true,
        },
    ];


    useEffect(() => {
        setColumns(columns1);
    }, []);

    const userData = JSON.parse(localStorage.getItem('userDataFs'));

    const getAllSessions = async () => {
        try {
            const dataString = {
                page: 1,
                per_page: 1000,
            };
            const response = await fetch(API_ROUTES.VIEW_CP_SERVICES, {
                method: "POST",
                body: objectToFormData(dataString),
                headers: { token: userData?.responseDetails?.token },
            });
            const responseJSON = await response.json();
            isAuthExpired(responseJSON);

            if (responseJSON.status.toString() === "200") {
                const responseData = responseJSON.data;

                const uniqueServices = Array.from(
                    new Map(
                        responseData.map((item) => [
                            item.serviceId,
                            {
                                serviceId: item.serviceId,
                                serviceName: item.serviceName,
                                network_id: item.network_id,
                            },
                        ])
                    ).values()
                ).sort((a, b) => a.serviceName.localeCompare(b.serviceName));

                setAllSessions(uniqueServices);
            }
        } catch (error) {
            console.log("Error getting data: ", error);
            setAllSessions([]);
        }
    };

    const getData = async (myFilters={}) => {
        const extractID = myFilters.cp_id.split("|")[0];
        const extractCP = myFilters.cp_id.split("|")[1];
        setCpSelected(extractCP);

        let dataString = {};
        if(myFilters){
            dataString = {
                cp_id: extractID,
                network_id: myFilters.network_id || "1",
                fro: myFilters.fro,
                to: myFilters.to,
            };
        }else{
            dataString = {
                cp_id: extractID,
                network_id: "1",
                fro: resetTimeToMidnight(formatDate(today)),
                to: resetTimeToB4Midnight(formatDate(today)),
            };
        }



        setIsFade(true);
        try {
            const response = await fetch(API_ROUTES.TOTAL_REVENUE2, {
                method: "POST",
                body: objectToFormData(dataString),
                headers: {'token': userData?.responseDetails?.token},
            });
            const responseJSON = await response.json();
            isAuthExpired(responseJSON); // check for expired login



            if (responseJSON.status.toString() === "200") {

                const responseData = responseJSON.data;

                const arrayData = [responseData];
                setDataRevenue(arrayData);
                setRawBreakdown(responseData.daily_breakdown || []);
                setIsLoading(false);
                setIsFade(false);
            }else{
                setDataRevenue(0);
                setRawBreakdown([]);
                setChartData([]);
                setChartCompanies([]);
                setIsLoading(false);
                setIsFade(false);
            }
        } catch (error) {
            console.log('Error getting data: ', error);
            setDataRevenue(0);
            setIsLoading(false);
            setIsFade(false);
        }
    }

    // console.log("ssss");
    // console.log(resetTimeToMidnight(formatDate(today)));
    // // console.log(today);


    useEffect(() => {
        if (!rawBreakdown.length) {
            setChartData([]);
            setChartCompanies([]);
            return;
        }
        const breakdown = rawBreakdown.map((item) => {
            const cp = allCPs.find((c) => String(c.id) === String(item.company));
            return { ...item, company: cp ? cp.name : item.company };
        });
        setChartData(transformBreakdown(breakdown));
        setChartCompanies([...new Set(breakdown.map((item) => item.company))]);
    }, [rawBreakdown, allCPs]);

    useEffect(() => {
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        getData({ cp_id: '', fro: resetTimeToMidnight(formatDate(yesterday)), to: resetTimeToB4Midnight(formatDate(yesterday)) });
        getAllSessions();
    }, []);


    const handleDuration = async (data) => {
        if(data.cp_id === ""){
            Swal.fire({
                title: "Error",
                text: "Please select a CP",
                icon: "error",
            });
            return;
        }
        let dataString = {
            cp_id: data.cp_id,
            network_id: data.network_id || "1",
            fro: data.fro + " 00:00:00",
            to: data.to + " 23:59:59",
        };

        getData(dataString);
    }



    return (
        <>

            <div className="flapt-page-wrapper mainContent">
                <Menus />

                <div className="flapt-page-content">
                    <HeaderTop />

                    <div className="main-content introduction-farm mt--20">
                        <div className="content-wraper-area">
                            <div className="dashboard-area">
                                <div className="container-fluid mb-90">
                                    <div className="card-header mb--30 mb-xs-10 ml-10">
                                        <h2>C.P Revenue</h2>
                                    </div>
                                    {
                                    isLoading1 ?
                                    <LoadingSpinner />
                                    :
                                    <div className="row g-4 ">
                                        <div className="col-lg-12 col-md-8 pl-xs-0 pr-xs-0 g-4">
                                            <RevenuesTable capitalizeWords={capitalizeWords} dataRevenue={dataRevenue} dataCount={dataCount} isLoading={isLoading} setIsLoading={setIsLoading} columns={columns} countPerPage={countPerPage} setPage={setPage} isFade={isFade} handleDuration={handleDuration} registerName={registerName} clearInputs={clearInputs} isAuthExpired={isAuthExpired} cpSelected={cpSelected} allCPs={allCPs} userSessions={allSessions} networkData={networkData} />
                                            <RevenueChart chartData={chartData} chartCompanies={chartCompanies} />
                                        </div>
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <Footers />
                    </div>
                </div>
            </div>
        </>
    );
}